
  (() => {
    if (window.lavProductPurchasePopupReady) return;

    window.lavProductPurchasePopupReady = true;

    let activePopup = null;
    let lastTrigger = null;

    const escapeHtml = (value) => {
      const element = document.createElement('div');

      element.textContent = String(value ?? '');

      return element.innerHTML;
    };

    const cleanPrice = (value) => {
      return String(value || '')
        .replace(/\s*USD\b/gi, '')
        .trim();
    };

    const calculateTwentyPercentOff = ( price ) => {
      const originalPrice = String(price || '');

      const amountMatch = originalPrice.match( /[\d,]+(?:\.\d{1,2})?/ );

      if (!amountMatch) {
        return originalPrice;
      }

      const amount = Number(
        amountMatch[0].replace(/,/g, '')
      );

      if (!Number.isFinite(amount)) {
        return originalPrice;
      }

      const discountedAmount =
        (amount * 0.8).toLocaleString(
          'en-US',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        );

      return originalPrice.replace(
        amountMatch[0],
        discountedAmount
      );
    };

    const cleanSavings = (value) => {
      return String(value || '')
        .replace(/^Save\s*/i, '')
        .replace('%', '')
        .trim();
    };

    const initializeLaviniaQuickAdd = (
      root = document
    ) => {
      root
        .querySelectorAll(
          '.lav-product-card__quick-add-wrap'
        )
        .forEach((wrapper) => {
          const sourceIcon = wrapper.querySelector(
            ':scope > .lav-button__icon--bag'
          );

          const productTitle =
            wrapper
              .closest('.lav-product-card')
              ?.querySelector(
                '.lav-product-card__title'
              )
              ?.textContent
              ?.trim() || 'product';

          const subscriptionTrigger =
            wrapper.querySelector(
              '[data-lav-purchase-trigger]'
            );

          if (subscriptionTrigger) {
            if (
              sourceIcon &&
              !subscriptionTrigger.querySelector(
                ':scope > .lav-button__icon--bag'
              )
            ) {
              const clonedIcon =
                sourceIcon.cloneNode(true);

              subscriptionTrigger.prepend(
                clonedIcon
              );
            }

            subscriptionTrigger.setAttribute(
              'aria-label',
              `Choose a purchase option for ${productTitle}`
            );

            wrapper.dataset.lavQuickAddReady =
              'true';

            return;
          }

          const button = wrapper.querySelector(
            'add-to-cart-component .quick-add__button--add'
          );

          if (!sourceIcon || !button) return;

          if (
            !button.querySelector(
              ':scope > .lav-button__icon--bag'
            )
          ) {
            const clonedIcon =
              sourceIcon.cloneNode(true);

            button.prepend(clonedIcon);
          }

          button.setAttribute(
            'aria-label',
            `Add ${productTitle} to cart`
          );

          wrapper.dataset.lavQuickAddReady =
            'true';
        });
    };

    const closeLaviniaPurchasePopup = (
      callback
    ) => {
      if (!activePopup) {
        if (typeof callback === 'function') {
          callback();
        }

        return;
      }

      const popupToRemove = activePopup;
      const triggerToFocus = lastTrigger;

      activePopup = null;
      lastTrigger = null;

      popupToRemove.classList.remove(
        'is-visible'
      );

      popupToRemove.classList.add(
        'is-closing'
      );

      document.documentElement.classList.remove(
        'lav-purchase-popup-open'
      );

      document.body.classList.remove(
        'lav-purchase-popup-open'
      );

      window.setTimeout(() => {
        popupToRemove.remove();

        if (triggerToFocus) {
          triggerToFocus.focus();
        }

        if (typeof callback === 'function') {
          callback();
        }
      }, 320);
    };

    const createPlanRows = (plans) => {
      return plans
        .map((plan, index) => {
          return `
            <label class="lav-purchase-popup__plan">
              <input
                type="radio"
                name="selling_plan"
                value="${escapeHtml(plan.id)}"
                ${index === 0 ? 'checked' : ''}
              >

              <span
                class="lav-purchase-popup__radio"
                aria-hidden="true"
              ></span>

              <span class="lav-purchase-popup__plan-name">
                ${escapeHtml(plan.name)}
              </span>

              <span class="lav-purchase-popup__plan-save">
                Save ${escapeHtml(plan.savings)}%
              </span>

              <span class="lav-purchase-popup__plan-price">
                ${escapeHtml(plan.price)}
              </span>
            </label>
          `;
        })
        .join('');
    };

    const buildLaviniaPurchasePopup = (
      product
    ) => {
      const popup =
        document.createElement('section');

      popup.className =
        'lav-purchase-popup';
      const discountedOneTimePrice = calculateTwentyPercentOff(product.oneTimePrice );
      popup.innerHTML = `
        <button
          type="button"
          class="lav-purchase-popup__backdrop"
          data-lav-purchase-close
          aria-label="Close purchase options"
        ></button>

        <div
          class="lav-purchase-popup__dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="LavPurchasePopupHeading"
        >
          <button
            type="button"
            class="lav-purchase-popup__close"
            data-lav-purchase-close
            aria-label="Close purchase options"
          >
            <span aria-hidden="true">
              &times;
            </span>
          </button>

          <div class="lav-purchase-popup__media">
            <img
              class="lav-purchase-popup__image"
              src="${escapeHtml(
                product.productImage
              )}"
              alt="${escapeHtml(
                product.productTitle
              )}"
            >
          </div>

          <div class="lav-purchase-popup__content">
            <div class="lav-purchase-popup__eyebrow">
              A little treat for future you
            </div>

            <h2
              id="LavPurchasePopupHeading"
              class="lav-purchase-popup__heading"
            >
              Subscribe &amp; Save
            </h2>

            <p class="lav-purchase-popup__intro">
              Keep ${escapeHtml(
                product.productTitle
              )} coming and save every time.
            </p>

            <form
              class="lav-purchase-popup__form"
              data-lav-purchase-form
            >
              <input
                type="hidden"
                name="id"
                value="${escapeHtml(
                  product.variantId
                )}"
              >

              <input
                type="hidden"
                name="quantity"
                value="${escapeHtml(
                  product.quantity || 1
                )}"
              >

              <div
                class="lav-purchase-popup__plans"
                role="radiogroup"
                aria-label="Subscription frequency"
              >
                ${createPlanRows(product.plans)}
              </div>

              <button
                type="submit"
                class="lav-purchase-popup__subscribe"
              >
                Subscribe &amp; Save
              </button>

              <button
                type="button"
                class="lav-purchase-popup__one-time"
                data-lav-purchase-one-time
              >
                <span class="lav-purchase-popup__one-time-sentence">
                  No thanks, add one-time purchase —
                  <span class="lav-purchase-popup__one-time-current">${escapeHtml(
                    discountedOneTimePrice
                  )}</span>
                  <s class="lav-purchase-popup__one-time-original">${escapeHtml(
                    product.oneTimePrice
                  )}</s>
                </span>

                <span class="lav-purchase-popup__one-time-code">
                  Get 20% off with code WELCOME20
                </span>
              </button>

              <p class="lav-purchase-popup__terms">
                Auto-renews, skip or cancel anytime.
              </p>

              <p
                class="lav-purchase-popup__status"
                data-lav-purchase-status
                role="status"
                aria-live="polite"
              ></p>
            </form>
          </div>
        </div>
      `;

      return popup;
    };

    const showLaviniaPurchasePopup = (
      product,
      trigger
    ) => {
      if (
        !product ||
        !Array.isArray(product.plans) ||
        !product.plans.length
      ) {
        console.warn(
          '[Lavinia popup] No subscription plans were found.',
          product
        );

        return;
      }

      if (activePopup) {
        activePopup.remove();
        activePopup = null;
      }

      lastTrigger = trigger;

      const newPopup =
        buildLaviniaPurchasePopup(product);

      activePopup = newPopup;

      document.body.appendChild(newPopup);

      document.documentElement.classList.add(
        'lav-purchase-popup-open'
      );

      document.body.classList.add(
        'lav-purchase-popup-open'
      );

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (
            activePopup === newPopup &&
            newPopup.isConnected
          ) {
            newPopup.classList.add(
              'is-visible'
            );
          }
        });
      });

      window.setTimeout(() => {
        if (
          activePopup !== newPopup ||
          !newPopup.isConnected
        ) {
          return;
        }

        newPopup
          .querySelector(
            'input[name="selling_plan"]:checked'
          )
          ?.focus();
      }, 340);
    };

    const openProductCardPopup = (
      trigger
    ) => {
      const wrapper = trigger.closest(
        '.lav-product-card__quick-add-wrap'
      );

      if (!wrapper) return;

      const dataElement = wrapper.querySelector(
        '[data-lav-purchase-data]'
      );

      if (!dataElement) {
        console.warn(
          '[Lavinia popup] Product-card data was not found.'
        );

        return;
      }

      let product;

      try {
        product = JSON.parse(
          dataElement.textContent
        );
      } catch (error) {
        console.error(
          '[Lavinia popup] Product-card data could not be read.',
          error
        );

        return;
      }

      showLaviniaPurchasePopup(
        {
          ...product,
          quantity:
            Number(product.quantity) || 1
        },
        trigger
      );
    };

    const getProductPageForm = (
      element
    ) => {
      const form = element?.closest(
        'product-form-component form[data-type="add-to-cart-form"]'
      );

      return form || null;
    };

    const getProductPageSubscriptionContainer = (
      variantId
    ) => {
      const matchingSection =
        document.querySelector(
          `.shopify_subscriptions_app_block[data-variant-id="${CSS.escape(
            String(variantId)
          )}"]`
        );

      return (
        matchingSection?.closest(
          '.shopify_subscriptions_app_container'
        ) ||
        document.querySelector(
          '.shopify_subscriptions_app_container'
        )
      );
    };

    const getProductPagePlans = (
      subscriptionContainer
    ) => {
      if (!subscriptionContainer) {
        return [];
      }

      return Array.from(
        subscriptionContainer.querySelectorAll(
          'input[data-radio-type="selling_plan"][data-selling-plan-id]'
        )
      )
        .map((input) => {
          const label = input.closest('label');

          const frequency =
            label
              ?.querySelector(
                '.lav-subscription-option-frequency'
              )
              ?.textContent
              ?.trim() ||
            input
              .getAttribute('aria-label')
              ?.split(',')[0]
              ?.trim() ||
            'Subscribe & Save';

          const savings =
            label
              ?.querySelector(
                '.lav-subscription-option-savings'
              )
              ?.textContent
              ?.trim() ||
            '';

          const price =
            label
              ?.querySelector(
                '.lav-subscription-option-price'
              )
              ?.textContent
              ?.trim() ||
            cleanPrice(
              input.dataset.variantPrice
            );

          return {
            id:
              input.dataset.sellingPlanId,
            name: frequency,
            savings:
              cleanSavings(savings),
            price:
              cleanPrice(price)
          };
        })
        .filter((plan) => {
          return plan.id;
        });
    };

    const getProductPageImage = (
      productForm
    ) => {
      const addToCartComponent =
        productForm
          .closest('product-form-component')
          ?.querySelector(
            'add-to-cart-component[data-product-variant-media]'
          );

      let image =
        addToCartComponent?.dataset
          .productVariantMedia || '';

      if (image) {
        image = image.replace(
          /([?&])width=\d+/i,
          '$1width=900'
        );

        return image;
      }

      return (
        document
          .querySelector(
            '.product-information img[src], .product-media img[src], product-media img[src]'
          )
          ?.getAttribute('src') || ''
      );
    };

    const getProductPageTitle = (
      productForm
    ) => {
      const productContainer =
        productForm.closest(
          '.group-block-content'
        );

      return (
        productContainer
          ?.querySelector('h1')
          ?.textContent
          ?.trim() ||
        document
          .querySelector('main h1')
          ?.textContent
          ?.trim() ||
        document.title
      );
    };

    const getProductPagePopupData = (
      productForm
    ) => {
      const variantInput =
        productForm.querySelector(
          'input[name="id"]'
        );

      const quantityInput =
        productForm.querySelector(
          'input[name="quantity"]'
        );

      const variantId =
        variantInput?.value;

      if (!variantId) {
        return null;
      }

      const subscriptionContainer =
        getProductPageSubscriptionContainer(
          variantId
        );

      const oneTimeInput =
        subscriptionContainer?.querySelector(
          `input[data-radio-type="one_time_purchase"][data-variant-id="${CSS.escape(
            String(variantId)
          )}"]`
        ) ||
        subscriptionContainer?.querySelector(
          'input[data-radio-type="one_time_purchase"]'
        );

      const plans =
        getProductPagePlans(
          subscriptionContainer
        );

      return {
        productTitle:
          getProductPageTitle(productForm),

        productImage:
          getProductPageImage(productForm),

        variantId,

        quantity:
          Number(quantityInput?.value) || 1,

        oneTimePrice:
          cleanPrice(
            oneTimeInput?.dataset
              .variantPrice
          ),

        plans
      };
    };

    const shouldInterceptProductPageForm = (
      productForm
    ) => {
      if (!productForm) return false;

      const sellingPlanInput =
        productForm.querySelector(
          'input[name="selling_plan"]'
        );

      if (!sellingPlanInput) {
        return false;
      }

      /*
       * A selling-plan ID means the customer already
       * selected a subscription. Horizon should submit
       * normally without showing the popup.
       */
      if (sellingPlanInput.value.trim()) {
        return false;
      }

      const popupData =
        getProductPagePopupData(
          productForm
        );

      return Boolean(
        popupData?.plans?.length
      );
    };

    const openProductPagePopup = (
      productForm,
      trigger
    ) => {
      const product =
        getProductPagePopupData(
          productForm
        );

      if (!product) return;

      showLaviniaPurchasePopup(
        product,
        trigger
      );
    };

    const getHorizonCartSectionIds = () => {
      return Array.from(
        document.querySelectorAll(
          'cart-items-component[data-section-id]'
        )
      )
        .map((component) => {
          return component.dataset.sectionId;
        })
        .filter(Boolean);
    };

    const dispatchHorizonCartAdd = ({
      cart,
      response,
      variantId,
      quantity
    }) => {
      const event = new CustomEvent(
        'cart:update',
        {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: String(variantId),
            data: {
              source:
                'product-form-component',
              itemCount: quantity,
              variantId: String(variantId),
              sections:
                response.sections || {}
            }
          }
        }
      );

      document.dispatchEvent(event);
    };

    const openHorizonCartFallback = () => {
      const cartDrawer =
        document.querySelector(
          'cart-drawer-component'
        );

      if (
        cartDrawer &&
        typeof cartDrawer.open === 'function'
      ) {
        cartDrawer.open();

        return true;
      }

      return false;
    };

    const addLaviniaProductToCart = async (
      form,
      includeSellingPlan
    ) => {
      if (
        form.classList.contains('is-loading')
      ) {
        return;
      }

      const status = form.querySelector(
        '[data-lav-purchase-status]'
      );

      const formData = new FormData(form);

      if (!includeSellingPlan) {
        formData.delete('selling_plan');
      }

      const variantId =
        formData.get('id');

      const quantity =
        Number(formData.get('quantity')) || 1;

      const sectionIds =
        getHorizonCartSectionIds();

      if (sectionIds.length) {
        formData.set(
          'sections',
          sectionIds.join(',')
        );
      }

      form.classList.add('is-loading');

      if (status) {
        status.textContent = '';
      }

      try {
        const root =
          window.Shopify?.routes?.root || '/';

        const addResponse = await fetch(
          `${root}cart/add.js`,
          {
            method: 'POST',
            headers: {
              Accept: 'text/html',
              'X-Requested-With':
                'XMLHttpRequest'
            },
            body: formData
          }
        );

        const addResult =
          await addResponse.json();

        if (
          !addResponse.ok ||
          addResult.status
        ) {
          throw new Error(
            addResult.description ||
              addResult.message ||
              'This product could not be added to your cart.'
          );
        }

        const cartResponse = await fetch(
          `${root}cart.js`,
          {
            headers: {
              Accept: 'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

        if (!cartResponse.ok) {
          throw new Error(
            'The cart could not be refreshed.'
          );
        }

        const updatedCart =
          await cartResponse.json();

        closeLaviniaPurchasePopup(() => {
          dispatchHorizonCartAdd({
            cart: updatedCart,
            response: addResult,
            variantId,
            quantity
          });

          window.setTimeout(() => {
            const drawer =
              document.querySelector(
                'cart-drawer-component'
              );

            const dialog =
              drawer?.querySelector(
                'dialog'
              );

            if (!dialog?.open) {
              openHorizonCartFallback();
            }
          }, 100);
        });
      } catch (error) {
        console.error(
          '[Lavinia popup] Add to cart failed.',
          error
        );

        if (status) {
          status.textContent =
            error.message ||
            'This product could not be added to your cart.';
        }

        form.classList.remove(
          'is-loading'
        );
      }
    };

    const handleProductPageClick = (
      event
    ) => {
      const submitButton =
        event.target.closest(
          'product-form-component form[data-type="add-to-cart-form"] button[type="submit"][name="add"]'
        );

      if (!submitButton) return;

      const productForm =
        getProductPageForm(
          submitButton
        );

      if (
        !shouldInterceptProductPageForm(
          productForm
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      openProductPagePopup(
        productForm,
        submitButton
      );
    };

    const handleProductPageSubmit = (
      event
    ) => {
      const productForm =
        getProductPageForm(
          event.target
        );

      if (
        !shouldInterceptProductPageForm(
          productForm
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton =
        productForm.querySelector(
          'button[type="submit"][name="add"]'
        );

      openProductPagePopup(
        productForm,
        submitButton || productForm
      );
    };

    const handleLaviniaClick = (event) => {
      const quickAddWrapper =
        event.target.closest(
          '.lav-product-card__quick-add-wrap'
        );

      const subscriptionTrigger =
        event.target.closest(
          '[data-lav-purchase-trigger]'
        ) ||
        quickAddWrapper?.querySelector(
          '[data-lav-purchase-trigger]'
        );

      if (
        subscriptionTrigger &&
        quickAddWrapper?.contains(
          subscriptionTrigger
        )
      ) {
        event.preventDefault();
        event.stopPropagation();

        openProductCardPopup(
          subscriptionTrigger
        );

        return;
      }

      const closeButton =
        event.target.closest(
          '[data-lav-purchase-close]'
        );

      if (closeButton) {
        event.preventDefault();

        closeLaviniaPurchasePopup();

        return;
      }

      const oneTimeButton =
        event.target.closest(
          '[data-lav-purchase-one-time]'
        );

      if (oneTimeButton) {
        event.preventDefault();

        const form = oneTimeButton.closest(
          '[data-lav-purchase-form]'
        );

        if (form) {
          addLaviniaProductToCart(
            form,
            false
          );
        }
      }
    };

    const handleLaviniaSubmit = (event) => {
      const form = event.target.closest(
        '[data-lav-purchase-form]'
      );

      if (!form) return;

      event.preventDefault();

      addLaviniaProductToCart(
        form,
        true
      );
    };

    const handleLaviniaKeydown = (
      event
    ) => {
      if (
        event.key === 'Escape' &&
        activePopup
      ) {
        closeLaviniaPurchasePopup();
      }
    };

    const startLaviniaPurchasePopup = () => {
      initializeLaviniaQuickAdd();

      const observer =
        new MutationObserver(
          (mutations) => {
            mutations.forEach(
              (mutation) => {
                mutation.addedNodes.forEach(
                  (node) => {
                    if (
                      !(
                        node instanceof Element
                      )
                    ) {
                      return;
                    }

                    if (
                      node.matches(
                        '.lav-product-card__quick-add-wrap'
                      )
                    ) {
                      initializeLaviniaQuickAdd(
                        node.parentElement
                      );

                      return;
                    }

                    if (
                      node.querySelector(
                        '.lav-product-card__quick-add-wrap'
                      )
                    ) {
                      initializeLaviniaQuickAdd(
                        node
                      );
                    }
                  }
                );
              }
            );
          }
        );

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    /*
     * Capture the product-page click before Horizon's
     * native add-to-cart handler.
     */
    document.addEventListener(
      'click',
      handleProductPageClick,
      true
    );

    /*
     * Capture keyboard/native product-form submissions.
     */
    document.addEventListener(
      'submit',
      handleProductPageSubmit,
      true
    );

    document.addEventListener(
      'click',
      handleLaviniaClick
    );

    document.addEventListener(
      'submit',
      handleLaviniaSubmit
    );

    document.addEventListener(
      'keydown',
      handleLaviniaKeydown
    );

    if (
      document.readyState === 'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        startLaviniaPurchasePopup,
        {
          once: true
        }
      );
    } else {
      startLaviniaPurchasePopup();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeLaviniaQuickAdd(
          event.target
        );
      }
    );
  })();
